export default __webpack_public_path__ + "static/media/yacht5.425396a7.webp";